import React from "react";
import Header from "../../components/Header";

const LoadingPage = () => {
    return (
        <section className="browse">
            <Header/>
            <div className="browse__container">
            <div className="row">
                <div className="browse__content">
                    <center>
                        <img src="/loading_spinner.jpg"
                            style={{
                                marginTop: "25vh",
                                width: "10%",
                            }}
                        />
                    </center>
                </div>
            </div>
            </div>
        </section>
    )
}

export default LoadingPage;